import { useDatasetDataContext } from "pages/project/dataset/DatasetDataProvider";
import { useCallback } from "react";
import { File as DrsFile } from "graphql/_Types";
import { evictCacheFragment } from "utils/cache-fragments";
import { useDrsFileScheduleDeleteDjango } from "hooks/useDrsFileScheduleDeleteDjango";
import { useFileUploadContext } from "stores/upload/FileUploadProvider";
import { useProjectPermissionStore } from "pages/project/ProjectPermissionProvider";

type ScheduleDeleteFileParams = {
  fileId: DrsFile["id"];
};

export const useActionScheduleDeleteFile = () => {
  const { datasetMode } = useDatasetDataContext();
  const cancelFileUploads = useFileUploadContext((s) => s.cancelFileUploads);
  const { drsFileScheduleDelete } = useDrsFileScheduleDeleteDjango();
  const hasEditPermission = useProjectPermissionStore(
    (s) => s.permissions["edit"],
  );

  const getActionDef = useCallback(
    (params: ScheduleDeleteFileParams) => {
      const dateDeleted = new Date().toISOString();

      return {
        onEnqueue: () => {
          cancelFileUploads([params.fileId]);
          evictCacheFragment({
            __typename: "File",
            id: params.fileId,
          });
        },

        onDequeue: () => {
          return drsFileScheduleDelete(params.fileId, {
            date_deleted: dateDeleted,
          });
        },
      };
    },
    [cancelFileUploads, drsFileScheduleDelete],
  );

  const isDisabled = datasetMode.type !== "current" || !hasEditPermission;

  return {
    getActionDef,
    isDisabled,
  };
};
